module.exports = __webpack_public_path__ + "static/img/brand-second-2-new.610bf9d3.png";